import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ZkEButtonColor, ZkEButtonSize } from '@zenklub/ng-ui';
import { IDialogData } from 'app/interfaces/dialog.interface';

@Component({
	selector: 'zen-modal-confirm',
	templateUrl: './modal-confirm.component.html',
	styleUrls: ['./modal-confirm.component.scss'],
	encapsulation: ViewEncapsulation.ShadowDom,
})
export class ModalConfirmComponent {
	public title = 'Tem certeza?';
	public subtitle = 'Deseja confirmar a alteração?';
	public labelButton = 'Confirmar';
	public googleLogin: boolean;

	public buttonColorType = ZkEButtonColor;
	public buttonSizeType = ZkEButtonSize;

	constructor(
		public dialogRef: MatDialogRef<ModalConfirmComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IDialogData
	) {
		if (data) {
			const { title, subtitle, labelButton, googleLogin } = data;
			this.title = title;
			this.subtitle = subtitle;
			this.googleLogin = googleLogin;

			if (labelButton) {
				this.labelButton = labelButton;
			}
		}
	}

	onConfirm() {
		this.dialogRef.close(true);
	}

	onCancel() {
		this.dialogRef.close(false);
	}
}
